import script from "./UFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./UFilters.vue?vue&type=script&setup=true&lang=ts"

import "./UFilters.vue?vue&type=style&index=0&id=aba42c94&lang=css"

const __exports__ = script;

export default __exports__